import { Theme, useMediaQuery } from '@mui/material'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { makeStyles } from 'tss-react/mui'

import analytics from '@src/analytics'
import ManageBrandDialog from '@src/components/brands/ManageBrandDialog'
import ShareSettingDialog from '@src/components/content/organicCampaignDetails/ShareSettingDialog'
import DigitalAssetPermalinkDialog from '@src/components/downloadables/DigitalAssetPermalinkDialog'
import ShareAssetDialog from '@src/components/shareAssetDialog/ShareAssetDialog'
import ShareDialog from '@src/components/shareDialog/ShareDialog'
import { CustomFieldsContextProvider } from '@src/customFields/customFieldsContext'
import { useFeatureFlag } from '@src/lib/useFeatureFlag'

import ErrorBoundary from './ErrorBoundary'
import SideNav, { SIDENAV_WIDTH } from './SideNav/SideNav'
import TopNav from './TopNav/TopNav'

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    // TODO This should be handled by CssBaseline, but we're not ready for that.
    backgroundColor: theme.palette.background.default,
  },
  withSideNav: {
    marginLeft: SIDENAV_WIDTH,
  },
}))

interface FullNavProps {
  backgroundColor?: string
}

const FullNav: React.FC<React.PropsWithChildren<FullNavProps>> = (props) => {
  const { classes, cx } = useStyles()
  const isTablet = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))
  const [sideNavToggled, setSideNavToggled] = useState(false)
  const showSideNav = !isTablet || sideNavToggled
  const isShareFlowUpliftEnabled = useFeatureFlag('share-flow-uplift')

  // Hide the sidebar when the location changes.
  const history = useHistory()
  useEffect(() => {
    const stopListening = history.listen(() => {
      setSideNavToggled(false)
    })

    return stopListening
  }, [history])

  return (
    <CustomFieldsContextProvider>
      <div className={classes.root}>
        <TopNav
          isSidebarVisible={showSideNav}
          showHamburger={isTablet}
          onClickHamburger={() => {
            setSideNavToggled((x) => !x)
            analytics.track({
              event: 'Click',
              type: `nav-hamburger-${showSideNav ? 'close' : 'open'}`,
            })
          }}
        />

        <SideNav isOpen={showSideNav} />

        <div
          className={cx(classes.content, { [classes.withSideNav]: !isTablet })}
          style={{ backgroundColor: props.backgroundColor }}
        >
          <ErrorBoundary>{props.children}</ErrorBoundary>
        </div>

        <ManageBrandDialog />
        <DigitalAssetPermalinkDialog />
        {isShareFlowUpliftEnabled ? <ShareSettingDialog /> : undefined}
        {isShareFlowUpliftEnabled ? <ShareDialog /> : undefined}
        {isShareFlowUpliftEnabled ? <ShareAssetDialog /> : undefined}
      </div>
    </CustomFieldsContextProvider>
  )
}

export default FullNav
